import { sanitizeBindable, sanitizeBoolean, sanitizeBoundValue, sanitizeString } from './helpers';
export function sanitizeCheckbox(el) {
  const value = sanitizeBoundValue(el.value);
  if (!value) return null;
  const label = sanitizeBindable(el.label, sanitizeString);
  if (!label) return null;
  return {
    type: 'Checkbox',
    value,
    label,
    required: sanitizeBindable(el.required, sanitizeBoolean),
    disabled: sanitizeBindable(el.disabled, sanitizeBoolean)
  };
}